import React from "react";
import "./index.css";
import Login from "./pages/login";
import { Switch, Route } from "react-router-dom";
import ClientLayout from "./desktop/layouts/Client";
import ProviderLayout from './desktop/layouts/Provider'
import SignUp from "./pages/signUp";
import Companies from "./desktop/pages/Companies"
import ProviderLogin from "./pages/providerLogin/ProviderLogin"
import ProviderNewPassword from "./pages/providerLogin/ProviderNewPassword"
import DetailsCompany from "./desktop/pages/Companies/DetailsCompany"
import Home from "./desktop/pages/home";
import FirstAcess from "./desktop/layouts/Client/FirstClientAccess"
import AutoLogin from "./desktop/pages/AutoLogin";
import AdminLogin from "./adminPanel/AdminLogin";
import AdminLayout from "./adminPanel/AdminLayout";
import AdminResetPassword from "./adminPanel/AdminResetPassword";
import NotFound from "./pages/notFound/NotFound";
import ConfirmationData from "./pages/confirmationData/ConfirmationData";

const Desktop = () => (
  <Switch>

    <Route exact path="/" component={Home} />

    <Route exact path="/client/login" component={Login} />
    <Route exact path="/client/signup" component={SignUp} />
    <Route exact path="/client/newpassword" component={Login} />
    <Route exact path="/client/first-acess" component={FirstAcess} />
    <Route exact path="/client/confirmation-data" component={ConfirmationData} />
    <Route path="/client" render={props => <ClientLayout {...props} />} />

    <Route exact path="/auto-login" component={AutoLogin} />
    <Route exact path="/admin/login" component={AdminLogin} />
    <Route exact path="/admin/reset-password" component={AdminResetPassword} />
    <Route path="/admin" component={AdminLayout} />
    <Route exact path="/provider/login" component={ProviderLogin} />
    <Route exact path="/provider/newpassword" component={ProviderNewPassword} />
    <Route path="/provider" render={props => <ProviderLayout {...props} />} />
    <Route exact path="/companies" component={Companies} />
    <Route exact path="/companies/details/:sourceId/:id" component={DetailsCompany} />
    <Route path="*" component={NotFound} />

  </Switch>
);
export default Desktop;
